import React,{useEffect} from 'react';
import {BrowserRouter as Router , Switch , Route} from 'react-router-dom';
import './App.css';
import Header from './Header';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
import {useStateValue} from './StateProvider';
import {auth} from './firebase';
import About from './About';


function App() {
  const [{user}, dispatch] =useStateValue();
  useEffect(() => {
    const unsubscribe =auth.onAuthStateChanged((authUser) => {
      if(authUser){
        dispatch({
          type:"SET_USER",
          user:authUser
        })
      }else{
        dispatch({
          type:"SET_USER",
          user:null
        });
      }
    });
    return () =>{
      unsubscribe();
    }
  },[]);
  console.log("USER IS >>>",user);

  return (
    <Router>
    <div className="app">
     <Switch>
       <Route path="/checkout">
         <Header/>
         <Checkout/>
       </Route>
       <Route path="/login">
         <Login/>
       </Route>
       <Route path="/">
         <Header/>
         <Home/>  
       </Route>
       <Route path="/about">
         <Header/>
         <About/>  
       </Route>
     </Switch>
    </div>
    </Router> 
  );
}
const NO ="Not meant to be viewed on mobile"
console.log(NO)

export default App;
